import { render, staticRenderFns } from "./FavWarehouseSelector.vue?vue&type=template&id=48a59fa8&"
import script from "./FavWarehouseSelector.vue?vue&type=script&lang=js&"
export * from "./FavWarehouseSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports